module.exports = {
  modeloIA: "bizai-hermes2",
  google: {
    API_KEY: "",
    CLIENT_ID: "23144678283-oek7ncjmmrgkgmi2i56sc411gp71a8sp.apps.googleusercontent.com",
    SECRET: "",
    API_KEY_RECAPTCHA: 'AIzaSyDlMlrKDJE7pWkIfhqMsfbZGKoVjtwYtaU',
    PROJECT_ID_RECAPTCHA: 'defender-1760538584939',
    SITE_KEY_RECAPTCHA: '6LeKYOsrAAAAAKEsALD_V7b8-9t3lmfA8vHLjXXt'
  },
  facebook: {
    APP_ID: "",
  },
  firebaseConfig: {
    vapidKey: "BIVmvCDsDCgTEYFDwdmYvqiloCHi6CYtldi5BpAGRLXRiJsgsAoja7GyzWb1vNKK85-ODIM4BWVq3tLn0_0vYsY",
    apiKey: "AIzaSyBDXvXD_gLAI1UUer8n2A6yHrx0u9g1oUk",
    authDomain: "web-bizin.firebaseapp.com",
    projectId: "web-bizin",
    storageBucket: "web-bizin.appspot.com",
    messagingSenderId: "706114036210",
    appId: "1:706114036210:web:b8985c2cc04d866a82cb6b",
    measurementId: "G-DQJ9QCK7Y5"
  },
  NODE_ENV: 'production',
  SECRET_KEY: 'l5U2_dTEHnErvBWU_GEhUwWEj1WMW6r48mxku7Bzu94',
  API_PORT: 3041,
  URL_HOST: 'https://defenderv16.businessintegrator.com.br',
  URL_SERVER: 'https://api-defenderv16.businessintegrator.com.br',
  MSMAN_USERNAME: 'APP_COMUNICACAO',
  MSMAN_PASSWORD: 'Emakers@123',
  URL_MSMAN: 'https://msman-prd-oke.businessintegrator.com.br/', // PROD https://msman-prd-oke.businessintegrator.com.br
  URL_BIZIN: 'https://www.emkintegrator.com/businessintegrator'
}
